import angular from 'angular';
import solidarityRequestModalComponent from './solidarityRequestModal.component';

let solidarityRequestModalModule = angular.module('solidarityRequestModal', [
])

.component('solidarityRequestModal', solidarityRequestModalComponent)

.name;

export default solidarityRequestModalModule;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/components/solidarityRequestModal/solidarityRequestModal.js